<header [class]="'widget-title align-' + (design?.align || 'center')" [style.--title-size.px]="design?.fontSize || 16">
  <div class="title-row">
    @if (design?.icon) {
      <mat-icon class="title-icon">{{ design!.icon }}</mat-icon>
    }
    <p class="title-main">{{ title }}</p>
    <ng-content></ng-content>
  </div>

  <!-- Under the whole row: it starts under the icon -->
  @if (design?.description?.trim()) {
    <p class="title-description">{{ design!.description }}</p>
  }
</header>
